const baseVideoCarousel = {
  default: {},
  featuredVideo: {},
};

const videoCarousel = {
  products: {
    chart: baseVideoCarousel,
    chartblog: baseVideoCarousel,
    co: baseVideoCarousel,
    edu: baseVideoCarousel,
    scale: baseVideoCarousel,
    spark: baseVideoCarousel,
  },
};

export type VideoCarouselVariantsType = 'default' | 'featuredVideo';
export const videoCarouselVariants = Object.keys(baseVideoCarousel) as VideoCarouselVariantsType[];

export default videoCarousel;
